// Profile rendering and the reservation dialog's guest layout always use the new profile.
// The legacy rendering stays in the code but is no longer shown.
export var useShowNewProfile = function () { return true; };
